import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const Container = styled(Stack)(
  ({theme}) => css`
    position: relative;
    border-radius: 5px;
    overflow: hidden;

    flex-direction: column-reverse;

    ${theme.respondTo(
      'sm',
      css`
        flex-direction: row;
        max-height: 126px;
      `
    )};

    ${theme.respondTo(
      'md',
      css`
        flex-direction: row;
        max-height: 160px;
      `
    )};

    ${theme.respondTo(
      'lg',
      css`
        aspect-ratio: 5/1;
        max-height: 160px;
      `
    )};
  `
);
